import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, mergeProps as _mergeProps, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "factory-schema-node__name-cell" }
const _hoisted_2 = {
  key: 1,
  class: "factory-schema-node__name-spacer"
}
const _hoisted_3 = { class: "factory-schema-node__type-label" }
const _hoisted_4 = { class: "factory-schema-node__actions" }
const _hoisted_5 = {
  key: 0,
  class: "factory-schema-node__children"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_FactorySchemaNode = _resolveComponent("FactorySchemaNode", true)!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["factory-schema-node", { 'factory-schema-node--root': _ctx.depth === 0, 'factory-schema-node--nested': _ctx.depth > 0 }])
  }, [
    _createVNode(_component_v_sheet, {
      class: _normalizeClass(["factory-schema-node__row", { 'factory-schema-node__row--object': _ctx.isObjectField }]),
      variant: "outlined",
      rounded: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, {
          align: "start",
          class: "ma-0",
          density: "compact"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "3",
              class: "py-1"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  (_ctx.isObjectField)
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 0,
                        icon: _ctx.field.collapsed ? 'mdi-chevron-right' : 'mdi-chevron-down',
                        variant: "text",
                        density: "compact",
                        size: "small",
                        onClick: _ctx.toggleCollapsed
                      }, null, 8, ["icon", "onClick"]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_2)),
                  _createVNode(_component_v_text_field, {
                    "model-value": _ctx.field.name,
                    label: "Field",
                    density: "compact",
                    variant: "outlined",
                    "hide-details": "",
                    "onUpdate:modelValue": _ctx.updateName
                  }, null, 8, ["model-value", "onUpdate:modelValue"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "2",
              class: "py-1"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_select, {
                  "model-value": _ctx.field.type,
                  items: _ctx.typeItems,
                  "item-title": "title",
                  "item-value": "value",
                  label: "Type",
                  density: "compact",
                  variant: "outlined",
                  "hide-details": "",
                  "onUpdate:modelValue": _ctx.updateType
                }, {
                  selection: _withCtx(({ item }) => [
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_v_icon, {
                        icon: item.raw.icon,
                        size: "small"
                      }, null, 8, ["icon"]),
                      _createElementVNode("span", null, _toDisplayString(item.raw.title), 1)
                    ])
                  ]),
                  item: _withCtx(({ props, item }) => [
                    _createVNode(_component_v_list_item, _mergeProps(props, {
                      "prepend-icon": item.raw.icon,
                      title: item.raw.title
                    }), null, 16, ["prepend-icon", "title"])
                  ]),
                  _: 1
                }, 8, ["model-value", "items", "onUpdate:modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "auto",
              class: "factory-schema-node__required py-1"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_checkbox, {
                  "model-value": _ctx.field.required,
                  label: "Required",
                  color: "primary",
                  density: "compact",
                  "hide-details": "",
                  "onUpdate:modelValue": _ctx.updateRequired
                }, null, 8, ["model-value", "onUpdate:modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { class: "factory-schema-node__description py-1" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field, {
                  "model-value": _ctx.field.description,
                  label: "Description",
                  density: "compact",
                  variant: "outlined",
                  "hide-details": "",
                  "onUpdate:modelValue": _ctx.updateDescription
                }, null, 8, ["model-value", "onUpdate:modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "auto",
              class: "py-1"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  (_ctx.isObjectField)
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 0,
                        icon: "mdi-plus",
                        variant: "text",
                        density: "compact",
                        size: "small",
                        onClick: _ctx.addChild
                      }, null, 8, ["onClick"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_btn, {
                    icon: "mdi-delete-outline",
                    variant: "text",
                    density: "compact",
                    size: "small",
                    color: "error",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('delete')))
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["class"]),
    (_ctx.isObjectField && !_ctx.field.collapsed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.field.children, (child, childIndex) => {
            return (_openBlock(), _createBlock(_component_FactorySchemaNode, {
              key: child.id,
              field: child,
              depth: _ctx.depth + 1,
              onUpdate: ($event: any) => (_ctx.updateChild(childIndex, $event)),
              onDelete: ($event: any) => (_ctx.deleteChild(childIndex))
            }, null, 8, ["field", "depth", "onUpdate", "onDelete"]))
          }), 128)),
          _createVNode(_component_v_btn, {
            class: "factory-schema-node__add-child",
            "prepend-icon": "mdi-plus",
            variant: "outlined",
            density: "compact",
            onClick: _ctx.addChild
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode(" Add Nested Field ")
            ])),
            _: 1,
            __: [1]
          }, 8, ["onClick"])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}